import { render, staticRenderFns } from "./delete-dynamic-screen.vue?vue&type=template&id=41ce4e92&scoped=true"
import script from "./delete-dynamic-screen.vue?vue&type=script&lang=js"
export * from "./delete-dynamic-screen.vue?vue&type=script&lang=js"
import style0 from "./delete-dynamic-screen.vue?vue&type=style&index=0&id=41ce4e92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ce4e92",
  null
  
)

export default component.exports